import { BatchesService } from '@festina/unitlinkdatareplicator-general-types/unitlinkdatareplicator/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServiceDeleteDelete
type MethodParam = Parameters<typeof method>[0]

export const useDeleteUnitlinkDataReplicatorBatch = () =>
  useFestinaMutation({
    component: 'unitLinkDataReplicator',
    isScenario: false,
    roles: BatchesService.batchesServiceDeleteDelete_roles,
    mutateFunction: async (arg: MethodParam) => await method(arg),
  })
